import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["elements", "title"]);

  return (state: AppState, props: EntityRef): MapProps => {
    const settings = settingsSelector(state, props);

    return {
      ...props,

      isSearchVisible: settings.elements.includes("search"),
      isTitleVisible: settings.elements.includes("title"),
      title: settings.title
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
